
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6wMuu", function(module, exports) {

$parcel$export(module.exports, "saveLocParams", function () { return $4c0b5877e0547ae3$export$816be54fd2c1857d; });
$parcel$export(module.exports, "initLoc", function () { return $4c0b5877e0547ae3$export$4dc9bce783e5bbc5; });
$parcel$export(module.exports, "setTextToElement", function () { return $4c0b5877e0547ae3$export$d40eaf7f02e82c0b; });
$parcel$export(module.exports, "t", function () { return (parcelRequire("frM9m")).t; });

var $7Ff5S = parcelRequire("7Ff5S");

var $hXoW9 = parcelRequire("hXoW9");
var $frM9m = parcelRequire("frM9m");
function $4c0b5877e0547ae3$export$816be54fd2c1857d({ orgId: orgId, eventCode: eventCode }) {
    sessionStorage.setItem('locParams', JSON.stringify({
        orgId: orgId,
        eventCode: eventCode
    }));
}
function $4c0b5877e0547ae3$var$getLocParams() {
    return JSON.parse(sessionStorage.getItem('locParams') || '{}');
}
async function $4c0b5877e0547ae3$export$4dc9bce783e5bbc5({ orgId: orgId, eventCode: eventCode } = $4c0b5877e0547ae3$var$getLocParams()) {
    if (!orgId || !eventCode) {
        const error = new Error('Organisation ID and Event Code are required for localisation initialization.');
        $7Ff5S.captureException(error);
    }
    await (0, $hXoW9.initLoc)({
        orgId: orgId,
        eventCode: eventCode,
        projectName: 'webapp'
    });
}
function $4c0b5877e0547ae3$export$d40eaf7f02e82c0b(cssPath, text) {
    const element = document.querySelector(cssPath);
    if (element) element.textContent = text;
    else {
        const error = new Error(`Element not found for CSS path: ${cssPath}`);
        console.error(error);
        $7Ff5S.captureException(error);
    }
}

});
parcelRegister("hXoW9", function(module, exports) {

$parcel$export(module.exports, "initLoc", function () { return $d12b4a48d2ac9516$export$4dc9bce783e5bbc5; });
$parcel$export(module.exports, "t", function () { return (parcelRequire("frM9m")).t; });

var $frM9m = parcelRequire("frM9m");

var $jG9hW = parcelRequire("jG9hW");

var $hAS4R = parcelRequire("hAS4R");
async function $d12b4a48d2ac9516$export$4dc9bce783e5bbc5({ orgId: orgId, eventCode: eventCode, projectName: projectName }) {
    await (0, $frM9m.default).use((0, $jG9hW.default)).use((0, $hAS4R.default)).init({
        fallbackLng: 'en',
        load: 'languageOnly',
        debug: true,
        supportedLngs: [
            'en'
        ],
        backend: {
            cdn: "https://d2fwkf6vxxjp7h.cloudfront.net",
            orgId: orgId,
            eventCode: eventCode,
            projectName: projectName
        },
        ns: [
            'common'
        ],
        defaultNS: 'common'
    });
}
async function $d12b4a48d2ac9516$export$61465194746e7fd2(lng) {
    return (0, $frM9m.default).changeLanguage(lng);
}
function $d12b4a48d2ac9516$export$604ba5624273df44() {
    return (0, $frM9m.default).language;
}

});
parcelRegister("frM9m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3eeba3b3a1cab1e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "t", function () { return $b3eeba3b3a1cab1e$export$625550452a3fa3ec; });
const $b3eeba3b3a1cab1e$var$isString = (obj)=>typeof obj === 'string';
const $b3eeba3b3a1cab1e$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $b3eeba3b3a1cab1e$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $b3eeba3b3a1cab1e$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $b3eeba3b3a1cab1e$var$lastOfPathSeparatorRegExp = /###/g;
const $b3eeba3b3a1cab1e$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($b3eeba3b3a1cab1e$var$lastOfPathSeparatorRegExp, '.') : key;
const $b3eeba3b3a1cab1e$var$canNotTraverseDeeper = (object)=>!object || $b3eeba3b3a1cab1e$var$isString(object);
const $b3eeba3b3a1cab1e$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$b3eeba3b3a1cab1e$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($b3eeba3b3a1cab1e$var$canNotTraverseDeeper(object)) return {};
        const key = $b3eeba3b3a1cab1e$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($b3eeba3b3a1cab1e$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $b3eeba3b3a1cab1e$var$cleanKey(stack[stackIndex])
    };
};
const $b3eeba3b3a1cab1e$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $b3eeba3b3a1cab1e$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $b3eeba3b3a1cab1e$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $b3eeba3b3a1cab1e$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $b3eeba3b3a1cab1e$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $b3eeba3b3a1cab1e$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $b3eeba3b3a1cab1e$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $b3eeba3b3a1cab1e$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $b3eeba3b3a1cab1e$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $b3eeba3b3a1cab1e$var$getPath(data, key);
    if (value !== undefined) return value;
    return $b3eeba3b3a1cab1e$var$getPath(defaultData, key);
};
const $b3eeba3b3a1cab1e$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($b3eeba3b3a1cab1e$var$isString(target[prop]) || target[prop] instanceof String || $b3eeba3b3a1cab1e$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $b3eeba3b3a1cab1e$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $b3eeba3b3a1cab1e$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $b3eeba3b3a1cab1e$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $b3eeba3b3a1cab1e$var$escape = (data)=>{
    if ($b3eeba3b3a1cab1e$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$b3eeba3b3a1cab1e$var$_entityMap[s]);
    return data;
};
class $b3eeba3b3a1cab1e$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $b3eeba3b3a1cab1e$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $b3eeba3b3a1cab1e$var$looksLikeObjectPathRegExpCache = new $b3eeba3b3a1cab1e$var$RegExpCache(20);
const $b3eeba3b3a1cab1e$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $b3eeba3b3a1cab1e$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $b3eeba3b3a1cab1e$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $b3eeba3b3a1cab1e$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $b3eeba3b3a1cab1e$var$getCleanedCode = (code)=>code?.replace('_', '-');
const $b3eeba3b3a1cab1e$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $b3eeba3b3a1cab1e$var$Logger {
    constructor(concreteLogger, options1 = {}){
        this.init(concreteLogger, options1);
    }
    init(concreteLogger, options1 = {}) {
        this.prefix = options1.prefix || 'i18next:';
        this.logger = concreteLogger || $b3eeba3b3a1cab1e$var$consoleLogger;
        this.options = options1;
        this.debug = options1.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($b3eeba3b3a1cab1e$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $b3eeba3b3a1cab1e$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options1) {
        options1 = options1 || this.options;
        options1.prefix = options1.prefix || this.prefix;
        return new $b3eeba3b3a1cab1e$var$Logger(this.logger, options1);
    }
}
var $b3eeba3b3a1cab1e$var$baseLogger = new $b3eeba3b3a1cab1e$var$Logger();
class $b3eeba3b3a1cab1e$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $b3eeba3b3a1cab1e$var$ResourceStore extends $b3eeba3b3a1cab1e$var$EventEmitter {
    constructor(data, options1 = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options1;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options1 = {}) {
        const keySeparator = options1.keySeparator !== undefined ? options1.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options1.ignoreJSONStructure !== undefined ? options1.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($b3eeba3b3a1cab1e$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $b3eeba3b3a1cab1e$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$b3eeba3b3a1cab1e$var$isString(key)) return result;
        return $b3eeba3b3a1cab1e$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options1 = {
        silent: false
    }) {
        const keySeparator = options1.keySeparator !== undefined ? options1.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $b3eeba3b3a1cab1e$var$setPath(this.data, path, value);
        if (!options1.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options1 = {
        silent: false
    }) {
        for(const m in resources)if ($b3eeba3b3a1cab1e$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options1.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options1 = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $b3eeba3b3a1cab1e$var$getPath(this.data, path) || {};
        if (!options1.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $b3eeba3b3a1cab1e$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $b3eeba3b3a1cab1e$var$setPath(this.data, path, pack);
        if (!options1.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $b3eeba3b3a1cab1e$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options1, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options1, translator) ?? value;
        });
        return value;
    }
};
const $b3eeba3b3a1cab1e$var$checkedLoadedFor = {};
const $b3eeba3b3a1cab1e$var$shouldHandleAsObject = (res)=>!$b3eeba3b3a1cab1e$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $b3eeba3b3a1cab1e$var$Translator extends $b3eeba3b3a1cab1e$var$EventEmitter {
    constructor(services, options1 = {}){
        super();
        $b3eeba3b3a1cab1e$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options1;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $b3eeba3b3a1cab1e$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        return resolved?.res !== undefined;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$b3eeba3b3a1cab1e$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $b3eeba3b3a1cab1e$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $b3eeba3b3a1cab1e$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$b3eeba3b3a1cab1e$var$isString(opt.count);
        const hasDefaultValue = $b3eeba3b3a1cab1e$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $b3eeba3b3a1cab1e$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($b3eeba3b3a1cab1e$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $b3eeba3b3a1cab1e$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $b3eeba3b3a1cab1e$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $b3eeba3b3a1cab1e$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$b3eeba3b3a1cab1e$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $b3eeba3b3a1cab1e$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $b3eeba3b3a1cab1e$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($b3eeba3b3a1cab1e$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$b3eeba3b3a1cab1e$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($b3eeba3b3a1cab1e$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$b3eeba3b3a1cab1e$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $b3eeba3b3a1cab1e$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options1 = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options1);
        return this.resourceStore.getResource(code, ns, key, options1);
    }
    getUsedParamsDetails(options1 = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options1.replace && !$b3eeba3b3a1cab1e$var$isString(options1.replace);
        let data = useOptionsReplaceForData ? options1.replace : options1;
        if (useOptionsReplaceForData && typeof options1.count !== 'undefined') data.count = options1.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options1) {
        const prefix = 'defaultValue';
        for(const option in options1){
            if (Object.prototype.hasOwnProperty.call(options1, option) && prefix === option.substring(0, prefix.length) && undefined !== options1[option]) return true;
        }
        return false;
    }
}
class $b3eeba3b3a1cab1e$var$LanguageUtil {
    constructor(options1){
        this.options = options1;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $b3eeba3b3a1cab1e$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $b3eeba3b3a1cab1e$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $b3eeba3b3a1cab1e$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($b3eeba3b3a1cab1e$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($b3eeba3b3a1cab1e$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($b3eeba3b3a1cab1e$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($b3eeba3b3a1cab1e$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $b3eeba3b3a1cab1e$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $b3eeba3b3a1cab1e$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $b3eeba3b3a1cab1e$var$PluralResolver {
    constructor(languageUtils, options1 = {}){
        this.languageUtils = languageUtils;
        this.options = options1;
        this.logger = $b3eeba3b3a1cab1e$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options1 = {}) {
        const cleanedCode = $b3eeba3b3a1cab1e$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options1.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (!Intl) {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $b3eeba3b3a1cab1e$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $b3eeba3b3a1cab1e$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options1);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options1 = {}) {
        let rule = this.getRule(code, options1);
        if (!rule) rule = this.getRule('dev', options1);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options1 = {}) {
        return this.getSuffixes(code, options1).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options1 = {}) {
        let rule = this.getRule(code, options1);
        if (!rule) rule = this.getRule('dev', options1);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$b3eeba3b3a1cab1e$var$suffixesOrder[pluralCategory1] - $b3eeba3b3a1cab1e$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options1.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options1 = {}) {
        const rule = this.getRule(code, options1);
        if (rule) return `${this.options.prepend}${options1.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options1);
    }
}
const $b3eeba3b3a1cab1e$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $b3eeba3b3a1cab1e$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $b3eeba3b3a1cab1e$var$isString(key)) {
        path = $b3eeba3b3a1cab1e$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $b3eeba3b3a1cab1e$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $b3eeba3b3a1cab1e$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $b3eeba3b3a1cab1e$var$Interpolator {
    constructor(options1 = {}){
        this.logger = $b3eeba3b3a1cab1e$var$baseLogger.create('interpolator');
        this.options = options1;
        this.format = options1?.interpolation?.format || ((value)=>value);
        this.init(options1);
    }
    init(options1 = {}) {
        if (!options1.interpolation) options1.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options1.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $b3eeba3b3a1cab1e$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $b3eeba3b3a1cab1e$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $b3eeba3b3a1cab1e$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $b3eeba3b3a1cab1e$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $b3eeba3b3a1cab1e$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $b3eeba3b3a1cab1e$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $b3eeba3b3a1cab1e$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options1) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $b3eeba3b3a1cab1e$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options1,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($b3eeba3b3a1cab1e$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options1,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options1?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options1?.interpolation?.skipOnVariables !== undefined ? options1.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$b3eeba3b3a1cab1e$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $b3eeba3b3a1cab1e$var$regexSafe(this.escape(val)) : $b3eeba3b3a1cab1e$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options1);
                        value = $b3eeba3b3a1cab1e$var$isString(temp) ? temp : '';
                    } else if (options1 && Object.prototype.hasOwnProperty.call(options1, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$b3eeba3b3a1cab1e$var$isString(value) && !this.useRawValueToEscape) value = $b3eeba3b3a1cab1e$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options1 = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options1
            };
            clonedOptions = clonedOptions.replace && !$b3eeba3b3a1cab1e$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$b3eeba3b3a1cab1e$var$isString(value)) return value;
            if (!$b3eeba3b3a1cab1e$var$isString(value)) value = $b3eeba3b3a1cab1e$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options1.lng, {
                    ...options1,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $b3eeba3b3a1cab1e$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $b3eeba3b3a1cab1e$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($b3eeba3b3a1cab1e$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $b3eeba3b3a1cab1e$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($b3eeba3b3a1cab1e$var$getCleanedCode(l), o)(v);
class $b3eeba3b3a1cab1e$var$Formatter {
    constructor(options1 = {}){
        this.logger = $b3eeba3b3a1cab1e$var$baseLogger.create('formatter');
        this.options = options1;
        this.init(options1);
    }
    init(services, options1 = {
        interpolation: {}
    }) {
        this.formatSeparator = options1.interpolation.formatSeparator || ',';
        const cf = options1.cacheInBuiltFormats ? $b3eeba3b3a1cab1e$var$createCachedFormatter : $b3eeba3b3a1cab1e$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $b3eeba3b3a1cab1e$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options1 = {}) {
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $b3eeba3b3a1cab1e$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options1?.formatParams?.[options1.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options1.locale || options1.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options1,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $b3eeba3b3a1cab1e$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $b3eeba3b3a1cab1e$var$Connector extends $b3eeba3b3a1cab1e$var$EventEmitter {
    constructor(backend, store, services, options1 = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options1;
        this.logger = $b3eeba3b3a1cab1e$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options1.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options1.maxRetries >= 0 ? options1.maxRetries : 5;
        this.retryTimeout = options1.retryTimeout >= 1 ? options1.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options1.backend, options1);
    }
    queueLoad(languages, namespaces, options1, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options1.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $b3eeba3b3a1cab1e$var$pushPath(q.loaded, [
                lng
            ], ns);
            $b3eeba3b3a1cab1e$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options1 = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($b3eeba3b3a1cab1e$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($b3eeba3b3a1cab1e$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options1, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options1 = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options1,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $b3eeba3b3a1cab1e$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($b3eeba3b3a1cab1e$var$isString(args[1])) ret.defaultValue = args[1];
            if ($b3eeba3b3a1cab1e$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options1 = args[3] || args[2];
                Object.keys(options1).forEach((key)=>{
                    ret[key] = options1[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $b3eeba3b3a1cab1e$var$transformOptions = (options1)=>{
    if ($b3eeba3b3a1cab1e$var$isString(options1.ns)) options1.ns = [
        options1.ns
    ];
    if ($b3eeba3b3a1cab1e$var$isString(options1.fallbackLng)) options1.fallbackLng = [
        options1.fallbackLng
    ];
    if ($b3eeba3b3a1cab1e$var$isString(options1.fallbackNS)) options1.fallbackNS = [
        options1.fallbackNS
    ];
    if (options1.supportedLngs?.indexOf?.('cimode') < 0) options1.supportedLngs = options1.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options1.initImmediate === 'boolean') options1.initAsync = options1.initImmediate;
    return options1;
};
const $b3eeba3b3a1cab1e$var$noop = ()=>{};
const $b3eeba3b3a1cab1e$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $b3eeba3b3a1cab1e$var$I18n extends $b3eeba3b3a1cab1e$var$EventEmitter {
    constructor(options1 = {}, callback){
        super();
        this.options = $b3eeba3b3a1cab1e$var$transformOptions(options1);
        this.services = {};
        this.logger = $b3eeba3b3a1cab1e$var$baseLogger;
        this.modules = {
            external: []
        };
        $b3eeba3b3a1cab1e$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options1.isClone) {
            if (!this.options.initAsync) {
                this.init(options1, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options1, callback);
            }, 0);
        }
    }
    init(options1 = {}, callback) {
        this.isInitializing = true;
        if (typeof options1 === 'function') {
            callback = options1;
            options1 = {};
        }
        if (options1.defaultNS == null && options1.ns) {
            if ($b3eeba3b3a1cab1e$var$isString(options1.ns)) options1.defaultNS = options1.ns;
            else if (options1.ns.indexOf('translation') < 0) options1.defaultNS = options1.ns[0];
        }
        const defOpts = $b3eeba3b3a1cab1e$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$b3eeba3b3a1cab1e$var$transformOptions(options1)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options1.keySeparator !== undefined) this.options.userDefinedKeySeparator = options1.keySeparator;
        if (options1.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options1.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $b3eeba3b3a1cab1e$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $b3eeba3b3a1cab1e$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $b3eeba3b3a1cab1e$var$Formatter;
            const lu = new $b3eeba3b3a1cab1e$var$LanguageUtil(this.options);
            this.store = new $b3eeba3b3a1cab1e$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $b3eeba3b3a1cab1e$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $b3eeba3b3a1cab1e$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $b3eeba3b3a1cab1e$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $b3eeba3b3a1cab1e$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $b3eeba3b3a1cab1e$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $b3eeba3b3a1cab1e$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $b3eeba3b3a1cab1e$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $b3eeba3b3a1cab1e$var$noop) {
        let usedCallback = callback;
        const usedLng = $b3eeba3b3a1cab1e$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $b3eeba3b3a1cab1e$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $b3eeba3b3a1cab1e$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $b3eeba3b3a1cab1e$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $b3eeba3b3a1cab1e$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $b3eeba3b3a1cab1e$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($b3eeba3b3a1cab1e$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${o.keyPrefix}${keySeparator}${k}`);
            else resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            return this.t(resultKey, o);
        };
        if ($b3eeba3b3a1cab1e$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options1 = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options1.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options1.precheck) {
            const preResult = options1.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $b3eeba3b3a1cab1e$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($b3eeba3b3a1cab1e$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $b3eeba3b3a1cab1e$var$defer();
        if ($b3eeba3b3a1cab1e$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $b3eeba3b3a1cab1e$var$LanguageUtil($b3eeba3b3a1cab1e$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options1 = {}, callback) {
        return new $b3eeba3b3a1cab1e$var$I18n(options1, callback);
    }
    cloneInstance(options1 = {}, callback = $b3eeba3b3a1cab1e$var$noop) {
        const forkResourceStore = options1.forkResourceStore;
        if (forkResourceStore) delete options1.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options1,
            isClone: true
        };
        const clone = new $b3eeba3b3a1cab1e$var$I18n(mergedOptions);
        if (options1.debug !== undefined || options1.prefix !== undefined) clone.logger = clone.logger.clone(options1);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $b3eeba3b3a1cab1e$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $b3eeba3b3a1cab1e$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $b3eeba3b3a1cab1e$export$2e2bcd8739ae039 = $b3eeba3b3a1cab1e$var$I18n.createInstance();
$b3eeba3b3a1cab1e$export$2e2bcd8739ae039.createInstance = $b3eeba3b3a1cab1e$var$I18n.createInstance;
const $b3eeba3b3a1cab1e$export$99152e8d49ca4e7d = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.createInstance;
const $b3eeba3b3a1cab1e$export$147ec2801e896265 = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.dir;
const $b3eeba3b3a1cab1e$export$2cd8252107eb640b = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.init;
const $b3eeba3b3a1cab1e$export$d3d08d944062d7e = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.loadResources;
const $b3eeba3b3a1cab1e$export$a5d9bf5d83fcab09 = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.reloadResources;
const $b3eeba3b3a1cab1e$export$1f96ae73734a86cc = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.use;
const $b3eeba3b3a1cab1e$export$61465194746e7fd2 = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.changeLanguage;
const $b3eeba3b3a1cab1e$export$f90d180fc7da3b3b = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.getFixedT;
const $b3eeba3b3a1cab1e$export$625550452a3fa3ec = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.t;
const $b3eeba3b3a1cab1e$export$f7e9f41ea797a17 = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.exists;
const $b3eeba3b3a1cab1e$export$2b4b218e406d2d00 = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.setDefaultNamespace;
const $b3eeba3b3a1cab1e$export$93d9ee97c1ad3f31 = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.hasLoadedNamespace;
const $b3eeba3b3a1cab1e$export$83be934b53fff43b = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.loadNamespaces;
const $b3eeba3b3a1cab1e$export$8cd7e7a54fa865bc = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.loadLanguages;

});

parcelRegister("jG9hW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5392509cecfc3c8$export$2e2bcd8739ae039; });
const { slice: $e5392509cecfc3c8$var$slice, forEach: $e5392509cecfc3c8$var$forEach } = [];
function $e5392509cecfc3c8$var$defaults(obj) {
    $e5392509cecfc3c8$var$forEach.call($e5392509cecfc3c8$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $e5392509cecfc3c8$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $e5392509cecfc3c8$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $e5392509cecfc3c8$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$e5392509cecfc3c8$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$e5392509cecfc3c8$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $e5392509cecfc3c8$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $e5392509cecfc3c8$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name) {
        this.create(name, '', -1);
    }
};
var $e5392509cecfc3c8$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $e5392509cecfc3c8$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $e5392509cecfc3c8$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $e5392509cecfc3c8$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
let $e5392509cecfc3c8$var$hasLocalStorageSupport = null;
const $e5392509cecfc3c8$var$localStorageAvailable = ()=>{
    if ($e5392509cecfc3c8$var$hasLocalStorageSupport !== null) return $e5392509cecfc3c8$var$hasLocalStorageSupport;
    try {
        $e5392509cecfc3c8$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$e5392509cecfc3c8$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $e5392509cecfc3c8$var$hasLocalStorageSupport = false;
    }
    return $e5392509cecfc3c8$var$hasLocalStorageSupport;
};
var $e5392509cecfc3c8$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $e5392509cecfc3c8$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $e5392509cecfc3c8$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $e5392509cecfc3c8$var$hasSessionStorageSupport = null;
const $e5392509cecfc3c8$var$sessionStorageAvailable = ()=>{
    if ($e5392509cecfc3c8$var$hasSessionStorageSupport !== null) return $e5392509cecfc3c8$var$hasSessionStorageSupport;
    try {
        $e5392509cecfc3c8$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$e5392509cecfc3c8$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $e5392509cecfc3c8$var$hasSessionStorageSupport = false;
    }
    return $e5392509cecfc3c8$var$hasSessionStorageSupport;
};
var $e5392509cecfc3c8$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $e5392509cecfc3c8$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $e5392509cecfc3c8$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $e5392509cecfc3c8$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $e5392509cecfc3c8$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $e5392509cecfc3c8$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return language[index]?.replace('/', '');
    }
};
var $e5392509cecfc3c8$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $e5392509cecfc3c8$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $e5392509cecfc3c8$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $e5392509cecfc3c8$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$e5392509cecfc3c8$var$canCookies) $e5392509cecfc3c8$var$order.splice(1, 1);
const $e5392509cecfc3c8$var$getDefaults = ()=>({
        order: $e5392509cecfc3c8$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $e5392509cecfc3c8$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $e5392509cecfc3c8$var$defaults(options, this.options || {}, $e5392509cecfc3c8$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($e5392509cecfc3c8$var$cookie$1);
        this.addDetector($e5392509cecfc3c8$var$querystring);
        this.addDetector($e5392509cecfc3c8$var$localStorage);
        this.addDetector($e5392509cecfc3c8$var$sessionStorage);
        this.addDetector($e5392509cecfc3c8$var$navigator$1);
        this.addDetector($e5392509cecfc3c8$var$htmlTag);
        this.addDetector($e5392509cecfc3c8$var$path);
        this.addDetector($e5392509cecfc3c8$var$subdomain);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$e5392509cecfc3c8$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$e5392509cecfc3c8$export$2e2bcd8739ae039.type = 'languageDetector';

});

parcelRegister("hAS4R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccefbf1daf1929b9$export$2e2bcd8739ae039; });

var $72VJ8 = parcelRequire("72VJ8");

var $fd2xD = parcelRequire("fd2xD");
var $a2fRy = parcelRequire("a2fRy");

var $8fp0t = parcelRequire("8fp0t");
class $ccefbf1daf1929b9$export$2e2bcd8739ae039 {
    static type = 'backend';
    init(services, backendOptions = {}, i18nextOptions = {}) {
        this.services = services;
        this.options = backendOptions;
        this.i18nextOptions = i18nextOptions;
        this.orgBackend = new (0, $72VJ8.default)();
        // All translations are now stored at org level only
        this.orgBackend.init(services, {
            loadPath: `${backendOptions.cdn}/${backendOptions.orgId}/${backendOptions.projectName}/{{lng}}/{{ns}}.json`
        }, i18nextOptions);
    }
    read(language, namespace, callback) {
        const { eventCode: eventCode } = this.options;
        this.orgBackend.read(language, namespace, (err, data)=>{
            let orgData = data;
            if (err) {
                console.warn('[I18nOCCOBackend] Failed to read from org source:', err);
                orgData = {};
            }
            const fallbackData = (0, $a2fRy.default)([
                this.options.projectName,
                language,
                namespace
            ], (0, $8fp0t.default)) || {};
            // Transform nested structure to flat key-value pairs
            // Structure: { "key": { "value": "org-level", "eventCode1": "event-specific" } }
            const transformedOrgData = Object.entries(orgData || {}).reduce((acc, [key, val])=>{
                // Use event-specific value if exists, otherwise use org-level value
                acc[key] = eventCode && val[eventCode] !== undefined ? val[eventCode] : val.value;
                return acc;
            }, {});
            const merged = (0, $fd2xD.default)(fallbackData, transformedOrgData);
            callback(null, merged);
        });
    }
}

});
parcelRegister("72VJ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52157fb216d7b4ed$export$2e2bcd8739ae039; });

var $cl44U = parcelRequire("cl44U");

var $lvhMn = parcelRequire("lvhMn");
function $52157fb216d7b4ed$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $52157fb216d7b4ed$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $52157fb216d7b4ed$var$_typeof(o);
}
function $52157fb216d7b4ed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $52157fb216d7b4ed$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $52157fb216d7b4ed$var$ownKeys(Object(t), !0).forEach(function(r) {
            $52157fb216d7b4ed$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $52157fb216d7b4ed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $52157fb216d7b4ed$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $52157fb216d7b4ed$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $52157fb216d7b4ed$var$_toPropertyKey(o.key), o);
    }
}
function $52157fb216d7b4ed$var$_createClass(e, r, t) {
    return r && $52157fb216d7b4ed$var$_defineProperties(e.prototype, r), t && $52157fb216d7b4ed$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $52157fb216d7b4ed$var$_defineProperty(e, r, t) {
    return (r = $52157fb216d7b4ed$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $52157fb216d7b4ed$var$_toPropertyKey(t) {
    var i = $52157fb216d7b4ed$var$_toPrimitive(t, "string");
    return "symbol" == $52157fb216d7b4ed$var$_typeof(i) ? i : i + "";
}
function $52157fb216d7b4ed$var$_toPrimitive(t, r) {
    if ("object" != $52157fb216d7b4ed$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $52157fb216d7b4ed$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $52157fb216d7b4ed$var$getDefaults = function getDefaults() {
    return {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        addPath: '/locales/add/{{lng}}/{{ns}}',
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $52157fb216d7b4ed$var$_defineProperty({}, key, fallbackValue || '');
        },
        parseLoadPayload: function parseLoadPayload(languages, namespaces) {
            return undefined;
        },
        request: (0, $lvhMn.default),
        reloadInterval: typeof window !== 'undefined' ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: 'cors',
            credentials: 'same-origin',
            cache: 'default'
        }
    };
};
var $52157fb216d7b4ed$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $52157fb216d7b4ed$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = 'backend';
        this.init(services, options, allOptions);
    }
    return $52157fb216d7b4ed$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $52157fb216d7b4ed$var$_objectSpread($52157fb216d7b4ed$var$_objectSpread($52157fb216d7b4ed$var$_objectSpread({}, $52157fb216d7b4ed$var$getDefaults()), this.options || {}), options);
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) {
                    var timer = setInterval(function() {
                        return _this.reload();
                    }, this.options.reloadInterval);
                    if ($52157fb216d7b4ed$var$_typeof(timer) === 'object' && typeof timer.unref === 'function') timer.unref();
                }
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === 'function') loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $cl44U.makePromise)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
                        lng: languages.join('+'),
                        ns: namespaces.join('+')
                    });
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                var lng = typeof languages === 'string' ? [
                    languages
                ] : languages;
                var ns = typeof namespaces === 'string' ? [
                    namespaces
                ] : namespaces;
                var payload = this.options.parseLoadPayload(lng, ns);
                this.options.request(this.options, url, payload, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
                    if (!res && err && err.message) {
                        var errorMessage = err.message.toLowerCase();
                        var isNetworkError = [
                            'failed',
                            'fetch',
                            'network',
                            'load'
                        ].find(function(term) {
                            return errorMessage.indexOf(term) > -1;
                        });
                        if (isNetworkError) return callback('failed loading ' + url + ': ' + err.message, true);
                    }
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === 'string') ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = 'failed parsing ' + url + ' to json';
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === 'string') languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === 'function') addPath = _this4.options.addPath(lng, namespace);
                    var url = _this4.services.interpolator.interpolate(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (typeof callback === 'function') callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, 'read', null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
}();
$52157fb216d7b4ed$var$Backend.type = 'backend';
var $52157fb216d7b4ed$export$2e2bcd8739ae039 = $52157fb216d7b4ed$var$Backend;

});
parcelRegister("cl44U", function(module, exports) {

$parcel$export(module.exports, "hasXMLHttpRequest", function () { return $8fba9c06a56c1a24$export$87022daa49baf612; });
$parcel$export(module.exports, "makePromise", function () { return $8fba9c06a56c1a24$export$1625492ec82002b9; });
function $8fba9c06a56c1a24$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8fba9c06a56c1a24$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8fba9c06a56c1a24$var$_typeof(o);
}
var $8fba9c06a56c1a24$var$arr = [];
var $8fba9c06a56c1a24$var$each = $8fba9c06a56c1a24$var$arr.forEach;
var $8fba9c06a56c1a24$var$slice = $8fba9c06a56c1a24$var$arr.slice;
function $8fba9c06a56c1a24$export$ebe90cb607ad99e(obj) {
    $8fba9c06a56c1a24$var$each.call($8fba9c06a56c1a24$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $8fba9c06a56c1a24$export$87022daa49baf612() {
    return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : $8fba9c06a56c1a24$var$_typeof(XMLHttpRequest)) === 'object';
}
function $8fba9c06a56c1a24$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === 'function';
}
function $8fba9c06a56c1a24$export$1625492ec82002b9(maybePromise) {
    if ($8fba9c06a56c1a24$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}

});

parcelRegister("lvhMn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa7a48ce65104d4c$export$2e2bcd8739ae039; });

var $cl44U = parcelRequire("cl44U");
function $fa7a48ce65104d4c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fa7a48ce65104d4c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fa7a48ce65104d4c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fa7a48ce65104d4c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fa7a48ce65104d4c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fa7a48ce65104d4c$var$_defineProperty(e, r, t) {
    return (r = $fa7a48ce65104d4c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fa7a48ce65104d4c$var$_toPropertyKey(t) {
    var i = $fa7a48ce65104d4c$var$_toPrimitive(t, "string");
    return "symbol" == $fa7a48ce65104d4c$var$_typeof(i) ? i : i + "";
}
function $fa7a48ce65104d4c$var$_toPrimitive(t, r) {
    if ("object" != $fa7a48ce65104d4c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fa7a48ce65104d4c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fa7a48ce65104d4c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fa7a48ce65104d4c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fa7a48ce65104d4c$var$_typeof(o);
}
var $fa7a48ce65104d4c$var$fetchApi = typeof fetch === 'function' ? fetch : undefined;
if (typeof $parcel$global !== 'undefined' && $parcel$global.fetch) $fa7a48ce65104d4c$var$fetchApi = $parcel$global.fetch;
else if (typeof window !== 'undefined' && window.fetch) $fa7a48ce65104d4c$var$fetchApi = window.fetch;
var $fa7a48ce65104d4c$var$XmlHttpRequestApi;
if ((0, $cl44U.hasXMLHttpRequest)()) {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.XMLHttpRequest) $fa7a48ce65104d4c$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== 'undefined' && window.XMLHttpRequest) $fa7a48ce65104d4c$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $fa7a48ce65104d4c$var$ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.ActiveXObject) $fa7a48ce65104d4c$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== 'undefined' && window.ActiveXObject) $fa7a48ce65104d4c$var$ActiveXObjectApi = window.ActiveXObject;
}
if (typeof $fa7a48ce65104d4c$var$fetchApi !== 'function') $fa7a48ce65104d4c$var$fetchApi = undefined;

if (!$fa7a48ce65104d4c$var$fetchApi && !$fa7a48ce65104d4c$var$XmlHttpRequestApi && !$fa7a48ce65104d4c$var$ActiveXObjectApi) try {
    (parcelRequire("jQII8")).then(function(mod) {
        $fa7a48ce65104d4c$var$fetchApi = mod.default;
    }).catch(function() {});
} catch (e) {}
var $fa7a48ce65104d4c$var$addQueryString = function addQueryString(url, params) {
    if (params && $fa7a48ce65104d4c$var$_typeof(params) === 'object') {
        var queryString = '';
        for(var paramName in params)queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
        if (!queryString) return url;
        url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
    }
    return url;
};
var $fa7a48ce65104d4c$var$fetchIt = function fetchIt(url, fetchOptions, callback, altFetch) {
    var resolver = function resolver(response) {
        if (!response.ok) return callback(response.statusText || 'Error', {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    };
    if (altFetch) {
        var altResponse = altFetch(url, fetchOptions);
        if (altResponse instanceof Promise) {
            altResponse.then(resolver).catch(callback);
            return;
        }
    }
    if (typeof fetch === 'function') fetch(url, fetchOptions).then(resolver).catch(callback);
    else $fa7a48ce65104d4c$var$fetchApi(url, fetchOptions).then(resolver).catch(callback);
};
var $fa7a48ce65104d4c$var$omitFetchOptions = false;
var $fa7a48ce65104d4c$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $fa7a48ce65104d4c$var$addQueryString(url, options.queryStringParams);
    var headers = $fa7a48ce65104d4c$var$_objectSpread({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
    if (typeof window === 'undefined' && typeof $parcel$global !== 'undefined' && typeof $parcel$global.process !== 'undefined' && $parcel$global.process.versions && $parcel$global.process.versions.node) headers['User-Agent'] = "i18next-http-backend (node/".concat($parcel$global.process.version, "; ").concat($parcel$global.process.platform, " ").concat($parcel$global.process.arch, ")");
    if (payload) headers['Content-Type'] = 'application/json';
    var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = $fa7a48ce65104d4c$var$_objectSpread({
        method: payload ? 'POST' : 'GET',
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, $fa7a48ce65104d4c$var$omitFetchOptions ? {} : reqOptions);
    var altFetch = typeof options.alternateFetch === 'function' && options.alternateFetch.length >= 1 ? options.alternateFetch : undefined;
    try {
        $fa7a48ce65104d4c$var$fetchIt(url, fetchOptions, callback, altFetch);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $fa7a48ce65104d4c$var$fetchIt(url, fetchOptions, callback, altFetch);
            $fa7a48ce65104d4c$var$omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $fa7a48ce65104d4c$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $fa7a48ce65104d4c$var$_typeof(payload) === 'object') payload = $fa7a48ce65104d4c$var$addQueryString('', payload).slice(1);
    if (options.queryStringParams) url = $fa7a48ce65104d4c$var$addQueryString(url, options.queryStringParams);
    try {
        var x = $fa7a48ce65104d4c$var$XmlHttpRequestApi ? new $fa7a48ce65104d4c$var$XmlHttpRequestApi() : new $fa7a48ce65104d4c$var$ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
        x.open(payload ? 'POST' : 'GET', url, 1);
        if (!options.crossDomain) x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        if (x.overrideMimeType) x.overrideMimeType('application/json');
        var h = options.customHeaders;
        h = typeof h === 'function' ? h() : h;
        if (h) for(var i in h)x.setRequestHeader(i, h[i]);
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $fa7a48ce65104d4c$var$request = function request(options, url, payload, callback) {
    if (typeof payload === 'function') {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($fa7a48ce65104d4c$var$fetchApi && url.indexOf('file:') !== 0) return $fa7a48ce65104d4c$var$requestWithFetch(options, url, payload, callback);
    if ((0, $cl44U.hasXMLHttpRequest)() || typeof ActiveXObject === 'function') return $fa7a48ce65104d4c$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error('No fetch and no xhr implementation found!'));
};
var $fa7a48ce65104d4c$export$2e2bcd8739ae039 = $fa7a48ce65104d4c$var$request;

});
parcelRegister("jQII8", function(module, exports) {
module.exports = $parcel$import("1fhCl").then(()=>parcelRequire('3xLA7'));

});



parcelRegister("fd2xD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b12a0a98000b2ae7$export$2e2bcd8739ae039; });

var $dOqR5 = parcelRequire("dOqR5");

var $aROlV = parcelRequire("aROlV");
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */ var $b12a0a98000b2ae7$var$mergeDeepRight = /*#__PURE__*/ (0, $dOqR5.default)(function mergeDeepRight(lObj, rObj) {
    return (0, $aROlV.default)(function(k, lVal, rVal) {
        return rVal;
    }, lObj, rObj);
});
var $b12a0a98000b2ae7$export$2e2bcd8739ae039 = $b12a0a98000b2ae7$var$mergeDeepRight;

});
parcelRegister("dOqR5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0e4c6c51bf5c217$export$2e2bcd8739ae039; });

var $lpfXx = parcelRequire("lpfXx");

var $jfKIm = parcelRequire("jfKIm");
function $a0e4c6c51bf5c217$export$2e2bcd8739ae039(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, $jfKIm.default)(a) ? f2 : (0, $lpfXx.default)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, $jfKIm.default)(a) && (0, $jfKIm.default)(b) ? f2 : (0, $jfKIm.default)(a) ? (0, $lpfXx.default)(function(_a) {
                    return fn(_a, b);
                }) : (0, $jfKIm.default)(b) ? (0, $lpfXx.default)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}

});
parcelRegister("lpfXx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9584ff410f094d8$export$2e2bcd8739ae039; });

var $jfKIm = parcelRequire("jfKIm");
function $f9584ff410f094d8$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $jfKIm.default)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}

});
parcelRegister("jfKIm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e043a792a0d4d9c8$export$2e2bcd8739ae039; });
function $e043a792a0d4d9c8$export$2e2bcd8739ae039(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}

});



parcelRegister("aROlV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e95e996ae53c0de$export$2e2bcd8739ae039; });

var $fF7BY = parcelRequire("fF7BY");

var $c4XcU = parcelRequire("c4XcU");

var $gDkGA = parcelRequire("gDkGA");
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var $7e95e996ae53c0de$var$mergeDeepWithKey = /*#__PURE__*/ (0, $fF7BY.default)(function mergeDeepWithKey(fn, lObj, rObj) {
    return (0, $gDkGA.default)(function(k, lVal, rVal) {
        if ((0, $c4XcU.default)(lVal) && (0, $c4XcU.default)(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
var $7e95e996ae53c0de$export$2e2bcd8739ae039 = $7e95e996ae53c0de$var$mergeDeepWithKey;

});
parcelRegister("fF7BY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b67096d358a17062$export$2e2bcd8739ae039; });

var $lpfXx = parcelRequire("lpfXx");

var $dOqR5 = parcelRequire("dOqR5");

var $jfKIm = parcelRequire("jfKIm");
function $b67096d358a17062$export$2e2bcd8739ae039(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, $jfKIm.default)(a) ? f3 : (0, $dOqR5.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, $jfKIm.default)(a) && (0, $jfKIm.default)(b) ? f3 : (0, $jfKIm.default)(a) ? (0, $dOqR5.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $jfKIm.default)(b) ? (0, $dOqR5.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $lpfXx.default)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, $jfKIm.default)(a) && (0, $jfKIm.default)(b) && (0, $jfKIm.default)(c) ? f3 : (0, $jfKIm.default)(a) && (0, $jfKIm.default)(b) ? (0, $dOqR5.default)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, $jfKIm.default)(a) && (0, $jfKIm.default)(c) ? (0, $dOqR5.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $jfKIm.default)(b) && (0, $jfKIm.default)(c) ? (0, $dOqR5.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $jfKIm.default)(a) ? (0, $lpfXx.default)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, $jfKIm.default)(b) ? (0, $lpfXx.default)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, $jfKIm.default)(c) ? (0, $lpfXx.default)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}

});

parcelRegister("c4XcU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cb3c915fad82d94$export$2e2bcd8739ae039; });
function $8cb3c915fad82d94$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
}

});

parcelRegister("gDkGA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1c055a83ffa9258$export$2e2bcd8739ae039; });

var $fF7BY = parcelRequire("fF7BY");

var $U36oK = parcelRequire("U36oK");
/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var $c1c055a83ffa9258$var$mergeWithKey = /*#__PURE__*/ (0, $fF7BY.default)(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    l = l || {};
    r = r || {};
    for(k in l)if ((0, $U36oK.default)(k, l)) result[k] = (0, $U36oK.default)(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ((0, $U36oK.default)(k, r) && !(0, $U36oK.default)(k, result)) result[k] = r[k];
    return result;
});
var $c1c055a83ffa9258$export$2e2bcd8739ae039 = $c1c055a83ffa9258$var$mergeWithKey;

});
parcelRegister("U36oK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a87a31bed377660$export$2e2bcd8739ae039; });
function $0a87a31bed377660$export$2e2bcd8739ae039(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});




parcelRegister("a2fRy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74e66552df694397$export$2e2bcd8739ae039; });

var $dOqR5 = parcelRequire("dOqR5");

var $l7N3M = parcelRequire("l7N3M");
/**
 * Retrieves the value at a given path. The nodes of the path can be arbitrary strings or non-negative integers.
 * For anything else, the value is unspecified. Integer paths are meant to index arrays, strings are meant for objects.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {a} -> a | Undefined
 * @sig Idx = String | NonNegativeInt
 * @param {Array} path The path to use.
 * @param {Object} obj The object or array to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop, R.nth, R.assocPath, R.dissocPath
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 *      R.path(['a', 'b', 0], {a: {b: [1, 2, 3]}}); //=> 1
 *      R.path(['a', 'b', -2], {a: {b: [1, 2, 3]}}); //=> 2
 *      R.path([2], {'2': 2}); //=> 2
 *      R.path([-2], {'-2': 'a'}); //=> undefined
 */ var $74e66552df694397$var$path = /*#__PURE__*/ (0, $dOqR5.default)(function path(pathAr, obj) {
    return (0, $l7N3M.default)([
        pathAr
    ], obj)[0];
});
var $74e66552df694397$export$2e2bcd8739ae039 = $74e66552df694397$var$path;

});
parcelRegister("l7N3M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6104eba586f4119$export$2e2bcd8739ae039; });

var $dOqR5 = parcelRequire("dOqR5");

var $lK5fw = parcelRequire("lK5fw");

var $aTns7 = parcelRequire("aTns7");
/**
 * Retrieves the values at given paths of an object.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Object
 * @typedefn Idx = [String | Int | Symbol]
 * @sig [Idx] -> {a} -> [a | Undefined]
 * @param {Array} pathsArray The array of paths to be fetched.
 * @param {Object} obj The object to retrieve the nested properties from.
 * @return {Array} A list consisting of values at paths specified by "pathsArray".
 * @see R.path
 * @example
 *
 *      R.paths([['a', 'b'], ['p', 0, 'q']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, 3]
 *      R.paths([['a', 'b'], ['p', 'r']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, undefined]
 */ var $f6104eba586f4119$var$paths = /*#__PURE__*/ (0, $dOqR5.default)(function paths(pathsArray, obj) {
    return pathsArray.map(function(paths) {
        var val = obj;
        var idx = 0;
        var p;
        while(idx < paths.length){
            if (val == null) return;
            p = paths[idx];
            val = (0, $lK5fw.default)(p) ? (0, $aTns7.default)(p, val) : val[p];
            idx += 1;
        }
        return val;
    });
});
var $f6104eba586f4119$export$2e2bcd8739ae039 = $f6104eba586f4119$var$paths;

});
parcelRegister("lK5fw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd41f741fadd07a2$export$2e2bcd8739ae039; });
/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */ var $fd41f741fadd07a2$export$2e2bcd8739ae039 = Number.isInteger || function _isInteger(n) {
    return n << 0 === n;
};

});

parcelRegister("aTns7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ee13b9f347e9ea2$export$2e2bcd8739ae039; });

var $dOqR5 = parcelRequire("dOqR5");

var $bsyWh = parcelRequire("bsyWh");
/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      const list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */ var $7ee13b9f347e9ea2$var$nth = /*#__PURE__*/ (0, $dOqR5.default)(function nth(offset, list) {
    var idx = offset < 0 ? list.length + offset : offset;
    return (0, $bsyWh.default)(list) ? list.charAt(idx) : list[idx];
});
var $7ee13b9f347e9ea2$export$2e2bcd8739ae039 = $7ee13b9f347e9ea2$var$nth;

});
parcelRegister("bsyWh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $857d695ffadcec6c$export$2e2bcd8739ae039; });
function $857d695ffadcec6c$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === '[object String]';
}

});




parcelRegister("8fp0t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60131f43a8adae6e$export$2e2bcd8739ae039; });

var $fb7mo = parcelRequire("fb7mo");

var $6L3Yv = parcelRequire("6L3Yv");

var $jUBlW = parcelRequire("jUBlW");

var $e2Z93 = parcelRequire("e2Z93");
var $60131f43a8adae6e$export$2e2bcd8739ae039 = {
    'universal-kiosk': {
        en: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($fb7mo)))
        },
        de: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($6L3Yv)))
        }
    },
    webapp: {
        en: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($jUBlW)))
        },
        de: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($e2Z93)))
        }
    }
};

});
parcelRegister("fb7mo", function(module, exports) {
module.exports = JSON.parse("{\"search-join-attendee-submit-btn\":\"DONE\",\"go-to-package-btn\":\"Purchase Options\",\"done-exit-btn\":\"Done (Exit Kiosk)\",\"title-select-package\":\"Select a Package\",\"title-suggest-a-product\":\"Would you like to add another product to your order?\",\"title-choose-a-product\":\"Pick a product to add to your order\",\"title-shopping-cart\":\"Shopping Cart\",\"select-images-notice-message\":\"Please select images you want to print.\",\"select-images-notice-ok\":\"OK\",\"confirm-change-img-btn\":\"OK, Use this image\"}");

});

parcelRegister("6L3Yv", function(module, exports) {
module.exports = JSON.parse("{\"search-join-attendee-submit-btn\":\"Erledigt\"}");

});

parcelRegister("jUBlW", function(module, exports) {
module.exports = JSON.parse("{\"title\":\"Welcome\",\"logout\":\"Log out\",\"item_one\":\"1 item\",\"item_few\":\"{{count}} items\",\"item_other\":\"{{count}} items\",\"submit-registration-btn\":\"GO\",\"purchase-btn\":\"Purchase\",\"title-select-a-combo\":\"Choose a Combo\",\"title-select-a-la-carte\":\"A La Carte\",\"title-shopping-cart\":\"Shopping Cart\",\"title-change-image\":\"Select photo\",\"title-registered-selfies\":\"Registered Faces\",\"title-privacy\":\"Terms and Conditions\",\"title-faq\":\"FAQ\",\"select-image-done-btn-name_final\":\"Done\",\"select-image-done-btn-name_incomplete\":\"Next\",\"select-image-done-btn-counter_finite\":\"({{amount}}/{{total}})\",\"select-image-done-btn-counter_infinite\":\"({{amount}})\",\"remote-shoot-btn\":\"Shoot\"}");

});

parcelRegister("e2Z93", function(module, exports) {
module.exports = JSON.parse('{"title":"Willkommen","logout":"Abmelden","item_one":"1 Gegenstand","item_few":"{{count}} Gegenst\xe4nde","item_other":"{{count}} Gegenst\xe4nde","submit-registration-btn":"GEHEN"}');

});





var $48b1ef51c25b822d$exports = {};
$parcel$extendImportMap({
    "1fhCl": "browser-ponyfill.1186cd03.js"
});


//# sourceMappingURL=a-shoot.968a3337.js.map
